import { render, staticRenderFns } from "./SingleRankingDisplay.vue?vue&type=template&id=aef4ea96&scoped=true"
import script from "./SingleRankingDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleRankingDisplay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SingleRankingDisplay.vue?vue&type=style&index=0&id=aef4ea96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef4ea96",
  null
  
)

export default component.exports